import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';

import { useMediaQuery } from '../services/MediaQuery.js';
import { validTokenHandler, permitHandler, jwtHandler } from '../services/Handlers.js';
import { logout } from '../services/LoginService';

import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';
import styled from 'styled-components';

const MenuWrapper = styled.div`
    .p-menubar-root-list {
        flex-wrap: wrap;
    }

    .p-submenu-list {
        width: auto;
    }

    .p-menubar-root-list > .p-menuitem:nth-last-child(-n+4) .p-submenu-list .p-submenu-list {
        left: auto;
        right: 100%;
    }
`;

const menus = jwtHandler() ? jwtHandler().menus : null;

/**
 *
 *  INICIO MENUS EXISTENTES
 *
 */

const menuEcoCane = [
    { label: 'Analise Laboratorio', icon: 'fa fa-flask', auth: 'laboratoryAnalysis', url: '/ecocane/analiseLaboratorio/' },
    { label: 'Amostra Laboratorio', icon: 'fa fa-flask', auth: 'laboratoryAnalysis', url: '/ecocane/amostraLaboratorio/' },
    { label: 'Pedidos', icon: 'fa fa-list-ol', auth: 'productionOrders', url: '/ecocane/pedidos/' },
    { label: 'Ordem Produção', icon: 'fa fa-id-badge', auth: 'product', url: '/ecocane/ordemproducao/' },
    { label: 'Vendedor Ecovida', icon: 'pi pi-money-bill', auth: 'ecovidaSeller', url: '/ecovida/vendedorEcovida' },
];

const menuContabilidade = [
    { label: 'Caixa', icon: 'fa fa-money', auth: 'consolidatedCash', url: '/contabilidade/caixa/' },
    { label: 'Ebit e Ebitda', icon: 'fa fa-clipboard', auth: 'ebit', url: '/contabilidade/ebit/consolidado/' },
    { label: 'Datas Impostos', icon: 'fa fa-calendar', auth: 'imposedDates', url: '/contabilidade/datasimpostos/' },
    { label: 'Relatorio Comissao', icon: 'fa fa-pencil-square-o', auth: 'commissionPersonCompanyReport', url: '/contabilidade/relatorioComissaoCadastros/' },
    { label: 'Relatorio Negocio', icon: 'fa fa-briefcase', auth: 'lineBusinessReport', url: '/contabilidade/relatorioNegocio' }
];

const menuLogistica = [
    { label: 'Canhoto de Viagem', icon: 'fa fa-ticket', auth: 'travelStub', url: '/logistica/canhotoNfeCteViagens/' },
    { label: 'Check List Motorista', icon: 'fa fa-check-square', auth: 'driversCheckList', url: '/logistica/checklistmotorista/enviar' },
    { label: 'Dashboard', icon: 'fa fa-area-chart', auth: 'dashboard', url: '/logistica/dashboard/' },
    { label: 'Ordem Carregamento (Biomassa)', icon: 'fa fa-road', auth: 'logisticsLoadingOrder', url: '/logistica/ordemcarregamento' },
    { label: 'Ordem de Embarque', icon: 'fa fa-id-card-o', auth: 'shippingOrder', url: '/logistica/ordemembarque' },
    { label: 'Rotas', icon: 'fa fa-exchange', auth: 'transportSaleCalculation', url: '/logistica/rotas/' },
    { label: 'Vale', icon: 'fa fa-fire', auth: 'voucher', url: '/logistica/vale/' },
];

const menuFinanceiro = [
    { label: 'Fluxo de Caixa Futuros', icon: 'fa fa-line-chart', auth: 'cashFlowForecast', url: '/financeiro/fluxocaixaprevisao/' },
    { label: 'Fluxo de Caixa Realizados', icon: 'fa fa-line-chart', auth: 'cashFlowForecast', url: '/financeiro/fluxocaixaRealizados/' },
];

const menuGeral = [
    { label: 'Compras', icon: 'fa fa-shopping-cart', auth: 'sketchPurchase', url: '/compras/esboco/' },
    { label: 'Aprovações', icon: 'fa fa-thumbs-up', auth: 'sketchPurchase', url: '/compras/aprovacoes/' },
    { label: 'Tempo Aprovação de Documentos', icon: 'fa fa-clock-o', auth: 'sketchPurchase', url: '/compras/tempoAprovacao/' },
    { label: 'Estoque', icon: 'fa fa-stack-exchange', auth: 'availableStock', url: '/compras/estoque/' },
    { label: 'Despesa Viagem', icon: 'fa fa-credit-card', auth: 'travelExpense', url: '/geral/despesasDeViagem/' },
    { label: 'Relatorios', icon: 'fa fa-file-text', auth: 'reportGeneral', url: '/geral/relatorios/' },
    { label: 'Usuarios', icon: 'fa fa-user', auth: 'userSystem', url: '/geral/usuarios/' },
    { label: 'Conta', icon: 'fa fa-key', auth: 'userNewPassword', url: '/geral/conta/' },
];

const menuFaturamento = [
    { label: 'Emissor Faturas', icon: 'fa fa-share-square', auth: 'invoiceSender', url: '/faturamento/emissorfatura/' },
    { label: 'Ordem Carregamento', icon: 'fa fa-road', auth: 'loadingOrder', url: '/faturamento/cadastraOrdemCarregamento/' },
];

const menuOperacional = [
    { label: 'Resultado Operação Maquinas', icon: 'fa fa-pie-chart', auth: 'costMachines', url: '/operacional/customaquinas' },
    { label: 'Grupos C.C', icon: 'fa fa-align-center', auth: 'groupCostCenter', url: '/operacional/centrocustocrupos' },
    { label: 'Orçamento', icon: 'fa fa-calculator', auth: 'budget', url: '/operacional/orcamento/lista' },
];

const menuAdministrativo = [
    { label: 'Abastecimentos', icon: 'fa fa-thermometer-half', auth: 'supplies', url: '/logistica/abastecimentos/' },
    { label: 'ADV Logística', icon: 'fa fa-tasks', auth: 'logisticsDailySalesAnalysis', url: '/administrativo/advlogistica' },
    { label: 'Compra Venda Biomassa', icon: 'fa fa-exchange', auth: 'buyingSellingBiomass', url: '/logistica/compravendabiomassa/' },
    { label: 'Gestão de Pátio', icon: 'fa fa-th-large', auth: 'yardManagement', url: '/administrativo/gestaopatio' },
    { label: 'Requisicao de Compra', icon: 'fa fa-shopping-cart', auth: 'purchaseRequisition', url: '/administrativo/requisicoes' },
    {
        label: 'NF Automática', icon: 'fa fa-file', items: [
            { label: 'Acompanhamento Notas', icon: 'fa fa-file', auth: 'invoiceReaderAdmin', url: '/administrativo/acompanhamento' },
            { label: 'Emissões Manual', icon: 'fa fa-cog', auth: 'invoiceReader', url: '/administrativo/nfe-nfs' },
            { label: 'Registro Leitura NFe ', icon: 'fa fa-search', auth: 'invoiceReaderAdmin', url: '/administrativo/leitura' },
            { label: 'Dashboard NF ', icon: 'fa fa-area-chart', auth: 'invoiceReaderAdmin', url: '/administrativo/dashboard' }
        ], auth: 'invoiceReaderAdmin'
    }

];

const menuComercial = [
    { label: 'Agenda CRM', icon: 'fa fa-calendar-o', auth: 'crmSchedule', url: '/logistica/agendacrm/' },
    { label: 'Calculo de Rotas', icon: 'fa fa-calculator', auth: 'routeCalculation', url: '/logistica/calculorota' },
    { label: 'Cotaçao de Biomassa', icon: 'fa fa-usd', auth: 'transportSaleCalculation', url: '/logistica/calculovenda/' },
    { label: 'Proposta Biomassa', icon: 'fa fa-copy', auth: 'biomassProposal', url: '/comercial/propostaBiomassa' }
];

const menuSsmt = [
    { label: 'Registro de Ocorrências', icon: 'fa fa-suitcase', auth: 'incidentReport', url: '/sst/registroOcorrencias/' },
    { label: 'Contratos', icon: 'fa fa-file-text', auth: ['contracts', 'contractsLookup', 'documentManagementAdmin'], url: '/administrativo/gestaodocumentos', param: 'contrato' },
    {
        label: 'Documentos', icon: 'fa fa-folder-open', items: [
            { label: 'Empresas', icon: 'fa fa-building', auth: ['businessDocuments', 'businessDocumentLookup', 'documentManagementAdmin'], url: '/administrativo/gestaodocumentos', param: 'empresa' },
            { label: 'RH / SST', icon: 'fa fa-users', auth: ['documentManagement', 'documentManagementInquiry', 'documentManagementAdmin'], url: '/administrativo/gestaodocumentos', param: 'pessoa' }
        ], auth: ['documentManagement', 'documentManagementInquiry', 'businessDocuments', 'businessDocumentLookup', 'documentManagementAdmin']
    },
    { label: 'Bloqueio de Motorista', icon: 'fa fa-lock', auth: 'driverLockout', url: '/sst/bloqueioDeMotorista' },
    { label: 'Portal Clientes Fornecedores', icon: 'fa fa-address-card', auth: 'supplierClientPortal', url: '/sst/portalClientesFornecedores' }
];

/**
 *
 *  FIM MENUS EXISTENTES
 *
 */

export default function MenuBar() {

    const location = useLocation();
    const is960px = useMediaQuery("(min-width: 961px)");

    const [itensEcoCane, setItensEcoCane] = useState([]);
    const [itensContabilidade, setItensContabilidade] = useState([]);
    const [itensLogistica, setItensLogistica] = useState([]);
    const [itensFinanceiro, setItensFinanceiro] = useState([]);
    const [itensGeral, setItensGeral] = useState([]);
    const [itensFaturamento, setItensFaturamento] = useState([]);
    const [itensOperacional, setItensOperacional] = useState([]);
    const [itensAdministrativo, setItensAdministrativo] = useState([]);
    const [itensComercial, setItensComercial] = useState([]);
    const [itensSsmt, setItensSsmt] = useState([]);

    useEffect(() => {

        validTokenHandler(location);

        setItensEcoCane(constructMenu(menuEcoCane));
        setItensContabilidade(constructMenu(menuContabilidade));
        setItensLogistica(constructMenu(menuLogistica));
        setItensFinanceiro(constructMenu(menuFinanceiro));
        setItensGeral(constructMenu(menuGeral));
        setItensFaturamento(constructMenu(menuFaturamento));
        setItensOperacional(constructMenu(menuOperacional));
        setItensAdministrativo(constructMenu(menuAdministrativo));
        setItensComercial(constructMenu(menuComercial));
        setItensSsmt(constructMenu(menuSsmt));

    }, [is960px]); // eslint-disable-line

    function exibeMenuItem(role) {
        return menus && menus.includes(role) ? 'hengelMenuItemEnable' : 'hengelMenuItemDisable';
    };

    let items = [
        { label: 'Contabilidade', icon: 'fa fa-calculator', className: exibeMenuItem('Contabilidade'), items: itensContabilidade },
        { label: 'EcoVida', icon: 'fa fa-leaf', className: exibeMenuItem('Fabrica'), items: itensEcoCane },
        { label: 'Faturamento', icon: 'fa fa-paper-plane', className: exibeMenuItem('Faturamento'), items: itensFaturamento },
        { label: 'Financeiro', icon: 'fa fa-university', className: exibeMenuItem('Financeiro'), items: itensFinanceiro },
        { label: 'Geral', icon: 'fa fa-universal-access', className: exibeMenuItem('Geral'), items: itensGeral },
        { label: 'Operacional', icon: 'fa fa-train', className: exibeMenuItem('Operacional'), items: itensOperacional },
        { label: 'Transporte', icon: 'fa fa-truck', className: exibeMenuItem('Logistica'), items: itensLogistica },
        { label: 'Administrativo', icon: 'fa fa-object-group', className: exibeMenuItem('Administrativo'), items: itensAdministrativo },
        { label: 'Comercial', icon: 'pi pi-compass', className: exibeMenuItem('Comercial'), items: itensComercial },
        { label: 'SST', icon: 'fa fa-shield', className: exibeMenuItem('SST'), items: itensSsmt }
    ];

    const sortMenu = (a, b) => {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
    };

    const constructMenu = (source) => {

        const target = [];

        source.forEach((item) => {
            if (permitHandler(item.auth)) {
                let url = item.url
                if (item.param) {
                    url = `${url}/${item.param}`
                }
                const itemMenu = {
                    label: item.label,
                    icon: item.icon,
                    style: { whiteSpace: is960px ? "nowrap" : "normal" }
                }
                if (item.items && item.items.length > 0) {
                    itemMenu.items = constructMenu(item.items);
                } else if (item.url) {
                    itemMenu.command = (e) => {
                        window.location.href = url;
                    }
                }

                target.push(itemMenu);
            }

        });

        target.sort((a, b) => sortMenu(a, b));

        return target;

    }

    return (
        <MenuWrapper>

            <Menubar
                model={items.sort((a, b) => sortMenu(a, b))}
                end={
                    <Button
                        onClick={() => { logout() }}
                        label="Logout"
                        icon="pi pi-power-off"
                        className="p-ml-3"
                    />
                }
            />

        </MenuWrapper>
    )

}
